import React from "react";
import { MDBDropdownMenu, MDBDropdown, MDBDropdownToggle, MDBDropdownItem } from 'mdbreact';
import {
    obtenerFechaLocalObjeto, construirFecha, convertirAMesACodigo, convertirCodigoAMeses, CodigoAMeses,
    traducirPagina, fechaInicial

} from "../librerias/funciones"

export const CPDia_Mes_Anyo = (props) => {
    const mesesDelAnio = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];

    const [filtroFecha, setFiltroFecha] = React.useState({
        ANYOS:[],
        CAMBIO_DIA: false,
        CAMBIO_MES: false,
        CAMBIO_ANIO: false,
        CAMBIO_CALENDARIO: false,
        ACCION_DESDE: 0,
        ACCION_HASTA: 0,
        FECHA_PARTIDA: "",

        DIA_SELECCIONADO: "",
        MES_SELECCIONADO: "",
        ANYO_SELECCIONADO: "",
        CODIGO_MES: 0
    });


  
  



    const fechaInicial = () => {
        let fechaLocal = obtenerFechaLocalObjeto(false);
        const FECHA_INICIAL = construirFecha(fechaLocal.MES, fechaLocal.ANIO.toString(), { DESDE: 2, HASTA: 3 })
        filtroFecha.CAMBIO_DIA = false;
        filtroFecha.CAMBIO_MES = false;
        
        filtroFecha.CAMBIO_ANIO = true;

        filtroFecha.ACCION_DESDE = 2;
        filtroFecha.ACCION_HASTA = 3;
        filtroFecha.FECHA_PARTIDA = FECHA_INICIAL
        filtroFecha.ANYO_SELECCIONADO = fechaLocal.ANIO
        filtroFecha.MES_SELECCIONADO = traducirPagina(convertirCodigoAMeses(fechaLocal.MES))
        filtroFecha.CODIGO_MES = fechaLocal.MES

        setFiltroFecha({ ...filtroFecha })
        return { FECHA_PARTIDA: FECHA_INICIAL, MES: parseInt(fechaLocal.MES), ANYO: fechaLocal.ANIO }
    }




    React.useEffect(() => {
        //props.OBJETO_COMPONENTE(filtroFecha,setFiltroFecha)

        let { MES, ANYO } = fechaInicial();
        let listaAnios = [];
        for (var i = 2018; i <= ANYO; i++) {
            listaAnios.push(i)
        }

        //setAnios(listaAnios)
        filtroFecha.MES_SELECCIONADO = CodigoAMeses(MES)
        filtroFecha.ANYOS = listaAnios
        setFiltroFecha({ ...filtroFecha })

        props.FECHA_INICIAL(filtroFecha,setFiltroFecha)


    }, [])




    
    const activarFecha = () => {
        if (document.getElementById("cp_dia") !== null) {
            let dia = document.getElementById("cp_dia");
            dia.classList.remove("cp_dia");
        }

        if (document.getElementById("cp_mes") !== null) {
            let mes = document.getElementById("cp_mes");
            mes.classList.remove("cp_mes");
        }

        if (document.getElementById("cp_anio") !== null) {
            let anio = document.getElementById("cp_anio");
            anio.classList.remove("cp_anio");
        }
    }



    return <div>


        {props.OCULTAR_DIA ?
            null
            :
            <MDBDropdown>
                <div onClick={() => {
                    activarFecha()
                    let fechaLocal = obtenerFechaLocalObjeto(false);
                    const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), filtroFecha.ANYO_SELECCIONADO, { DESDE: 4, HASTA: 5 });
                    filtroFecha.CAMBIO_DIA = true;
                    filtroFecha.CAMBIO_MES = false;
                    filtroFecha.CAMBIO_ANIO = false;
                    filtroFecha.ACCION_DESDE = 4;
                    filtroFecha.ACCION_HASTA = 5;
                    filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                    filtroFecha.ANYO_SELECCIONADO = fechaLocal.ANIO

                    setFiltroFecha({ ...filtroFecha })

                    //GetNoticias(1, "D", "", filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA)
                    props.ACTUALIZAR_TABLA(filtroFecha)

                }}>
                    <div id="cp_dia" style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_DIA ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', borderRadius: '4px 0px 0px 4px' }}>
                        {traducirPagina("Hoy").toUpperCase()}
                    </div>
                </div>
            </MDBDropdown>

        }

        <MDBDropdown>
            <MDBDropdownToggle nav>
                <div id="cp_mes" style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_MES ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', borderRadius:props.OCULTAR_DIA ? '4px 0px 0px 4px':'none' }}>
                    {traducirPagina(filtroFecha.MES_SELECCIONADO).toUpperCase()}
                </div>
            </MDBDropdownToggle>

            <MDBDropdownMenu right>
                {mesesDelAnio.map((mes, i) =>
                    <MDBDropdownItem style={{ padding: '10px' }} key={i} onClick={(e) => {
                        activarFecha()
                        let MES_LOCAL = CodigoAMeses((i + 1))

                        const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(MES_LOCAL), filtroFecha.ANYO_SELECCIONADO, { DESDE: 0, HASTA: 1 });

                        filtroFecha.CAMBIO_DIA = false;
                        filtroFecha.CAMBIO_MES = true;
                        filtroFecha.CAMBIO_ANIO = true;
                        filtroFecha.ACCION_DESDE = 0;
                        filtroFecha.ACCION_HASTA = 1;
                        filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA
                        filtroFecha.MES_SELECCIONADO = MES_LOCAL
                        filtroFecha.CODIGO_MES = (i + 1)


                        setFiltroFecha({ ...filtroFecha })

                        props.ACTUALIZAR_TABLA(filtroFecha)


                        //GetNoticias(1, "D", "", filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA)



                    }}>  {traducirPagina(mes).toUpperCase()}</MDBDropdownItem>
                )}
            </MDBDropdownMenu>
        </MDBDropdown>

        <MDBDropdown>
            <MDBDropdownToggle nav>
                <div id="cp_anio" style={{ padding: '8px 20px', backgroundColor: filtroFecha.CAMBIO_ANIO ? '#00468e' : '#a2a2a2', fontSize: '16px', fontWeight: '500', color: '#fff', borderRadius: '0px 4px 4px 0px' }}>
                    {filtroFecha.ANYO_SELECCIONADO}
                </div>
            </MDBDropdownToggle>

            <MDBDropdownMenu right >
                {filtroFecha.ANYOS !== null ?
                    filtroFecha.ANYOS.map((anio, i) =>
                        <MDBDropdownItem key={i} onClick={(e) => {
                            activarFecha()
                            const FECHA_PARTIDA = construirFecha(convertirAMesACodigo(filtroFecha.MES_SELECCIONADO), e.target.innerText, { DESDE: 2, HASTA: 3 });


                            filtroFecha.CAMBIO_DIA = false;
                            filtroFecha.CAMBIO_MES = false;
                            filtroFecha.CAMBIO_ANIO = true;
                            filtroFecha.ACCION_DESDE = 2;
                            filtroFecha.ACCION_HASTA = 3;
                            filtroFecha.FECHA_PARTIDA = FECHA_PARTIDA;
                            filtroFecha.ANYO_SELECCIONADO = parseInt(e.target.innerText);

                            setFiltroFecha({ ...filtroFecha })

                            props.ACTUALIZAR_TABLA(filtroFecha)


                            //GetNoticias(1, "D", "", filtroFecha.FECHA_PARTIDA, filtroFecha.ACCION_DESDE, filtroFecha.ACCION_HASTA)


                        }}>  {anio}</MDBDropdownItem>
                    )
                    :
                    null
                }
            </MDBDropdownMenu>
        </MDBDropdown>


    </div>;
};